var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-flex"},[_c('div',{staticClass:"ButtonThemeContainer"},[_c('button',{staticClass:"Button Button-transparent Button-theme u-floatRight",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('toggle-theme-builder')}}},[_c('span',{staticClass:"Icon-s Icon-brush"}),_vm._v(" Theme\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }